var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconEdit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M5.344 17.358H3v-2.344L13.23 4.736l2.344 2.353zm12.62-12.669-1.213 1.224-2.344-2.344 1.214-1.223a1.165 1.165 0 0 1 1.657 0l.687.687a1.165 1.165 0 0 1 0 1.656z",
  className: "icon-edit_svg__nc-icon-wrapper"
})));
export default SvgIconEdit;